import { Component, OnInit } from '@angular/core';
import { useSafeTimeout } from '@/app/shared/ssr-util';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '@/app/shared/services/account.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-register-program',
  templateUrl: './register-program.component.html',
  styleUrls: ['./register-program.component.scss']
})
export class RegisterProgramComponent implements OnInit {
  programSlug: string = '';
  program: any;
  gpsLink: string = '';
  agreed: boolean = false;

  registerFormat = 'Tôi là chủ tài khoản {SĐT đăng ký tài khoản}, tôi xác nhận đăng ký “Gói Đồng hành 2026"';

  private safeTimeout = useSafeTimeout();
  
  constructor(
    private route: ActivatedRoute,
    private accountService: AccountService,
    private toastr: ToastrService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.programSlug = this.route.snapshot.paramMap.get('slug')!;
    this.loadProgramDetails();
  }

  loadProgramDetails() {
    this.accountService.getMembershipProgramsBySlug(this.programSlug).subscribe({
      next: (res) => {
        this.program = res;
        //this.registerFormat = "Đăng ký " + this.program.name;
      },
      error: (err) => {
        this.toastr.error('Không tìm thấy chương trình');
      }
    });
  }

  registerEvent() {
    if (!this.isValidGpsLink(this.gpsLink)) {
      this.toastr.error('Vui lòng nhập đúng định dạng link Google Maps.', "", { timeOut: 2000 });
      return;
    }

    if (!this.agreed) {
      this.toastr.error('Vui lòng xác nhận đồng ý tham gia chương trình.', "", { timeOut: 2000 });
      return;
    }

    this.accountService.registerEvent(this.program.id, this.gpsLink).subscribe({
      next: () => {
        this.toastr.success('Đăng ký thành công!', "", { timeOut: 2000 });
        this.safeTimeout(() => {
          this.router.navigateByUrl('/account/companion');
        }, 1000);
      },
      error: (err) => {
        this.toastr.error(err.error.message, "", { timeOut: 2000 });
      }
    });
  }

  isValidGpsLink(link: string): boolean {
    try {
      const url = new URL(link.trim());
      const validHosts = [
        'www.google.com',
        'maps.google.com',
        'goo.gl',
        'maps.app.goo.gl'
      ];

      return validHosts.some(host => url.hostname === host || url.hostname.endsWith(`.${host}`));
    } catch {
      return false;
    }
  }

  copyToClipBoard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.toastr.success('Đã sao chép vào bộ nhớ tạm', "", { timeOut: 2000 });
    }).catch(err => {
      this.toastr.error('Sao chép thất bại', "", { timeOut: 2000 });
    });
  }
}
